import { render, staticRenderFns } from "./AddNewBarcodeCategory.vue?vue&type=template&id=0436483d"
import script from "./AddNewBarcodeCategory.vue?vue&type=script&lang=js"
export * from "./AddNewBarcodeCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports